import React, { useState } from 'react'

import { useMutation } from 'react-query'
import { toast } from 'react-toastify'

import { postBranches } from '../../../../MyApi/sb/branches'

import PageHeader from '../../../../Components/UI/PageHeader'
import AddBranch from '../../../../Components/sb/branches/branchesStore/AddBranch'



const BranchesStore = () => {
const [ branchName ,setBranchName]= useState("")
const [phone, setPhone] = useState("")
const [address, setAdress] = useState("")
const [timezone , setTimeZone] =useState("")
const [currencyId ,setCurrencyId] = useState("")
const [countryId ,setCountryId]= useState("")
const [companyId ,setCompanyId] = useState("")
const [cityId , setCityId]= useState("")
const [selectedCurrency , setSelectedCurrency] =useState("")
const [selectedCompany , setSelectedCompany] =useState("")
const [selectedCity , setSelectedCity] =useState("")
const [active, setActive]=useState(1)
const [mainStatus ,setMainStatus] =useState(1)
const [shiftId ,setShiftId] =useState([])
const [states ,setStates]=useState("")
const [locations , setLocations]=useState([])




 const mutation = useMutation("postBranches" , (postData)=>postBranches(postData) ,{
    onSuccess:(data)=>{
        toast.success(`${data.message}`)
        setBranchName("")
        setPhone("")
        setAdress("")
        setTimeZone("")
        setShiftId([])
        setStates("")
    },
    onError:(error)=>{
        toast.error(`${error.response.data.message}`)
    }
 })

 const handlePostRequest =()=>{
    mutation.mutate({
        name:branchName,
        phone,
        timezone,
        active,      
        sb_country_id:+countryId,
        sb_company_id:+companyId,
        sb_city_id:+cityId,
        sb_currency_id:+currencyId,
        address,
        shifts:shiftId,
        main:mainStatus,
        states,
        locations
    })
 } 
 const isDisabled= ()=>{
   return !(branchName && countryId &&phone && address && timezone && currencyId  &&shiftId  )
 }
  return ( 

    <div>
        <PageHeader title="Add Branch"  showBack={true} saveButton={true} isdisbled={isDisabled} handlePostRequest={handlePostRequest} />
        <AddBranch  countryId={countryId}  setLocations={setLocations}  setStates={setStates}  selectedCity={selectedCity}   selectedCurrency={selectedCurrency} selectedCountry={selectedCompany} setSelectedCompany={setSelectedCompany}   setShiftId={setShiftId} shiftId={shiftId}  setCityId={setCityId} setBranchName={setBranchName} setMainStatus={setMainStatus} mainStatus={mainStatus} setCompanyId={setCompanyId} setActive={setActive} setTimeZone={setTimeZone}  setCountryId={setCountryId} setAdress={setAdress} setPhone={setPhone} phone={phone} address={address} setCurrencyId={setCurrencyId}  active={active}  branchName={branchName}/>
    </div>
  )
}

export default BranchesStore